import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  Chip,
} from '@mui/material';
import image1 from "../../assets/training/WhatsApp Image 2025-06-02 at 11.50.28 AM.jpeg"
import image2 from "../../assets/training/image2.jpeg"
import image3 from "../../assets/training/image3.jpeg"
import image4 from "../../assets/training/image4.jpeg"
import image5 from "../../assets/training/image5.jpeg"
import image6 from "../../assets/training/image6.jpeg"

const courses = [
  {
    title: "Web Design Fundamentals",
    description:
      "Learn the fundamentals of web design, including HTML, CSS,Bootstrap and responsive design principles. Develop the skills to create visually appealing and user-friendly websites.",
    image: image1,
    duration: "4 Weeks",
    level: "Beginner",
    author: "John Smith",
  },
  {
    title: "UI/UX Design",
    description:
      "Master the art of creating intuitive user interfaces (UI) and enhancing user experiences (UX). Learn design principles, wireframing, prototyping, and usability testing techniques.",
    image: image2,
    duration: "6 Weeks",
    level: "Intermediate",
    author: "Emily Johnson",
  },
  {
    title: "Mobile App Development",
    description:
      "Learn the basics of mobile app development. Learn to build modern, responsive apps for both Android and iOS platforms using Flutter and React Native  React Native.",
    image: image3,
    duration: "3 Weeks",
    level: "Intermediate",
    author: "David Brown",
  },
  {
    title: "Graphic Design for Beginners",
    description:
      "Dive into the world of graphic design. Learn color theory, typography, composition, and popular tools like Adobe Photoshop and Illustrator.",
    image:image4,
    duration: "5 Weeks",
    level: "Beginner",
    author: "Sarah Thompson",
  },
  {
    title: "Front-End Web Development",
    description:
      "Become a front-end web developer. Learn HTML, CSS, JavaScript, modern frameworks like React, and build real-world projects.",
    image:image5,
    duration: "10 Weeks",
    level: "Advanced",
    author: "Michael Adams",
  },
  {
    title: "Advanced JavaScript",
    description:
      "Master JavaScript at an advanced level. Explore ES6+, closures, async/await, and build complex single-page apps.",
    image: image6,
    duration: "8 Weeks",
    level: "Advanced",
    author: "Jennifer Wilson",
  },
];

const Training = () => {
  return (
    <Box sx={{ p: { xs: 2, md: 4 }, backgroundColor: '#f5f5f5' }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}

      >
        <Box sx={{mt:"50px"}}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Our Training
          </Typography>
          <Typography variant="body2" color="text.secondary" >
            Lorem ipsum dolor sit amet consectetur. Tempus tincidunt etiam eget
            elit id imperdiet et. Cras eu sit dignissim lorem nibh et. Ac cum
            eget habitasse in velit fringilla feugiat senectus in.
          </Typography>
        </Box>
        <Button variant="text" sx={{ minWidth: 'fit-content' }}>
          View All
        </Button>
      </Box>

      <Grid container spacing={4}>
        {courses.map((course, idx) => (
          <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}key={idx}>
            <Card sx={{ borderRadius: 4, boxShadow: 0 }}>
            <Box p={2}>
  <CardMedia
    component="img"
    image={course.image}
    alt={course.title}
    sx={{
      width: "100%",
      height: 200,
      objectFit: "cover",
      borderRadius: 2, // Rounded corners inside the padding
    }}
  />
</Box>

              <CardContent>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                  <Chip label={course.duration} size="small" />
                  <Chip label={course.level} size="small" />
                  <Box flexGrow={1} />
                  <Typography variant="body2" fontWeight="medium">
                    By {course.author}
                  </Typography>
                </Box>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {course.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  {course.description}
                </Typography>
                <Button
                  fullWidth
                  variant="outlined"
                  sx={{
                    textTransform: 'none',
                    fontWeight: 'medium',
                    bgcolor: '#f7f7f8',
                  }}
                >
                  Get it Now
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Training;

